import { SEARCH_ON_MENU } from "../types";

export const searchingOption = (option) => ({
    type: SEARCH_ON_MENU,
    payload: option,
})